import usePublicSettings from '../../hooks/usePublicSettings.js';

export default function Logo({
  className = 'h-12',
  onDark = false,
  alt = 'ITEC Mobiles & Computers',
}) {
  const { settings } = usePublicSettings();
  const logoUrl = settings?.siteLogoUrl;

  if (logoUrl) {
    const img = (
      <img src={logoUrl} alt={settings?.siteName || alt} className={`w-auto ${className}`} />
    );
    return onDark ? (
      <span className="inline-flex items-center rounded-lg bg-white px-2.5 py-1.5">{img}</span>
    ) : (
      img
    );
  }

  const mark = (
    <svg
      viewBox="0 0 252 64"
      width="252"
      height="64"
      role="img"
      aria-label={alt}
      className={`w-auto ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{alt}</title>
      <rect x="0" y="13" width="8" height="38" rx="3" fill="#F68719" />
      <text
        x="22"
        y="41"
        fontFamily="Inter, system-ui, sans-serif"
        fontSize="34"
        fontWeight="800"
        letterSpacing="1.5"
        fill="#0C1331"
      >
        ITEC
      </text>
      <text
        x="23"
        y="57"
        fontFamily="Inter, system-ui, sans-serif"
        fontSize="9.5"
        fontWeight="600"
        letterSpacing="3"
        fill="#538BC4"
      >
        {'MOBILES & COMPUTERS'}
      </text>
    </svg>
  );

  if (onDark) {
    return (
      <span className="inline-flex items-center rounded-lg bg-white px-2.5 py-1.5">
        {mark}
      </span>
    );
  }
  return mark;
}
